import React,{useState} from 'react'
import Header from '../postercomponents/Header'
import '../postercomponents/poster.css'
import Posterfetch from '../postercomponents/Posterfetch'
import { Posterdata } from '../postercomponents/Posterdata'
const Poster = () => {

    const [cuerrentVideo, setcuerrentVideo] = useState(Posterdata[0])
    const [playing, setplaying] = useState(false)
    return (
        <>
        <div className='poster'>
            <Header cuerrentVideo={cuerrentVideo} playing={playing} setplaying={setplaying}/>
            <Posterfetch setcuerrentVideo={setcuerrentVideo} setplaying={setplaying} />
            
        </div>
        </>
    )
}

export default Poster
